<template>
  <div class="feedback">
    <div class="client">
      <div class="line1">
        <div class="left">Client Feedback:</div>
        <div class="right">
          <el-rate class="ra" v-model="orderDetail.reviews.star" :colors="[theme, theme, theme]" disabled v-if="orderDetail.reviews"></el-rate>
        </div>
      </div>
      <div class="line2" v-if="orderDetail.reviews">{{ orderDetail.reviews.content }}</div>
      <div class="line3">
        <i class="el-icon-circle-check"></i>
      </div>
    </div>
    <!-- <div class="writer">
      <div class="line1">
        <div class="left">Writer Feedback:</div>
        <div class="right">
          <el-rate class="ra" v-model="score" :colors="[theme, theme, theme]" disabled></el-rate>
        </div>
      </div>
      <div class="line2">
        aaaaaaaaaaaaa aaaaaaaaaaaaa aaaaaaaaaaaaa aaaaaaaaaaaaa aaaaaaaaaaaaaaaaaaaaaaa
        aaaaaaaaaaaaa aaaaaaaaaaaaaaaaaaaaaaaaaa aaaaaaaaaaaaa aaaaaaaaaaaaa aaaaaaaaaaaaa
      </div>
      <div class="line3">
        <i class="el-icon-circle-check"></i>
      </div>
    </div> -->
  </div>
</template>

<script>
import { writerTheme } from '@/styles/writer.scss';
export default {
  name: 'feedback',
  props: ['orderDetail'],
  data: function () {
    return {
      score: 4,
    };
  },
  computed: {
    theme() {
      return writerTheme;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/writer.scss';

.feedback {
  .client,
  .writer {
    background-color: #fff;
    padding: 30px 40px;
    border-radius: 10px;
    .line1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        line-height: 21px;
      }
    }
    .line2 {
      margin-top: 15px;
      font-size: 18px;
      font-weight: 400;
      color: #acacac;
      line-height: 24px;
      margin-left: 15px;
    }
    .line3 {
      margin-top: 15px;
      text-align: right;
      .el-icon-circle-check {
        color: $writerTheme;
        font-size: 30px;
      }
    }
  }
  .writer {
    margin-top: 40px;
  }
}
</style>
